import styled from '@emotion/styled';
import { Css, ITheme, Responsive, RowRole } from '../../../ui';
import { Color } from '../../../styles/Color';
import { IPolicyEntry } from '../../../contentful/types/IPolicyEntry';
import * as PolicyNumber from './columns/PolicyNumber';
import * as PolicyName from './columns/PolicyName';
import * as PolicyDescription from './columns/PolicyDescription';
import * as PolicyDownload from './columns/PolicyDownload';

interface IPolicyListRowProps {
	policy: IPolicyEntry;
}

const StyledRow = styled(RowRole)<{}, ITheme>`
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	border-bottom: 1px solid ${Color.Neutral2};
	height: fit-content;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(16)};
		padding: ${Css.pxToRem(16)} ${Css.pxToRem(8)};
		display: grid;
		grid-template-columns: auto 1fr auto;
		grid-template-areas:
			'number name download'
			'. description .';
		grid-gap: ${Css.pxToRem(8)};
	}
`;

export function PolicyListRow({ policy }: IPolicyListRowProps) {
	const { number, title, description, asset } = policy.fields;

	return (
		<StyledRow>
			<PolicyNumber.Cell number={number} />
			<PolicyName.Cell title={title} />
			<PolicyDescription.Cell description={description} />
			<PolicyDownload.Cell asset={asset} title={title} />
		</StyledRow>
	);
}
